<template>
  <div class="container" style="    margin-bottom: 20px;">
    <form action="/automotive/#wpcf7-f21-p22-o1" method="post" class="wpcf7-form" novalidate="novalidate">
      <div class="ibid-contact row" style="max-width: unset;">
        <template>
          <div class="col-md-12 pd-15">
            <form name="header-search-form" class="woocommerce-product-search">
              <h3 style="width: 50%;">Thanh toán thành công</h3>
            </form>
          </div>
          <div class="col-md-12 pd-15">
            <form name="header-search-form" class="woocommerce-product-search">
              <span style="width: 50%;">Mã giao dịch</span>
              <input required type="text" :value="code" class="search-field" style="width: 50%;height: unset;" />
            </form>
          </div>
          <div class="col-md-12 pd-15">
            <form name="header-search-form" class="woocommerce-product-search">
              <span style="width: 50%;">Mã số của quý khách trong phiên đấu giá là</span>
              <input required type="text" :value="codeUser" class="search-field" style="width: 50%;height: unset;" />
            </form>
          </div>
          <div class="col-md-12 pd-15">
            <form name="header-search-form" class="woocommerce-product-search">
              <span style="width: 50%;">Số tiền giao dịch</span>
              <input
                required
                type="text"
                :value="(detail.SoTienDatCoc + detail.PhiThamGiaDauGia).toLocaleString()"
                class="search-field"
                style="width: 50%;height: unset;"
              />
            </form>
          </div>
          <div class="col-md-12 pd-15">
            <form name="header-search-form" class="woocommerce-product-search">
              <span style="width: 50%;">Thời điểm bắt đầu phiên đấu giá</span>
              <input
                required
                type="text"
                :value="detail.BatDau"
                class="search-field"
                style="width: 50%;height: unset;"
              />
            </form>
          </div>
          <div class="col-md-12 pd-15">
            <form name="header-search-form" class="woocommerce-product-search">
              <span style="width: 50%;">Ngày đến xem tài sản</span>
              <input
                required
                type="text"
                :value="detail.NgayDenXemTaiSan"
                class="search-field"
                style="width: 50%;height: unset;"
              />
            </form>
          </div>
          <!-- <div class="col-md-6 pd-15">
               <form name="header-search-form" class="woocommerce-product-search" >
                  <span style="width: 50%;">Mã số của quý khách trong phiên đấu giá là</span>
                  <input required type="text" :value="code" class="search-field" style="width: 50%;height: unset;">
               </form>
            </div> -->
          <div class="col-md-12 pd-15" style="margin-top: 15px;">
            <form name="header-search-form" class="woocommerce-product-search">
              <span style="width: 50%;"
                >Chú ý:
                <code style="font-size: 15px;"
                  >Người tham gia đấu giá phải đăng nhập vào phòng đấu giá online chậm nhất trước
                  {{ detail.KetThuc | formatDate }}</code
                ></span
              >
            </form>
          </div>
          <div class="col-md-12 pd-15" style="margin-top: 15px;">
            <form name="header-search-form" class="woocommerce-product-search">
              <span style="width: 50%;"
                ><code style="font-size: 14px;"
                  >Khách hàng đã đăng ký xem hiện trạng tài sản đấu giá phải có mặt đúng thời gian và địa điểm theo
                  Thông báo mời tham gia đấu giá. Khi đến địa điểm xem tài sản Khách hàng phải thông báo mã số đăng ký
                  đã được hệ thống cấp (gọi là Mã số KH) và xuất trình CMND/CCCD/Hộ chiếu để kiểm tra tư cách khách hàng
                  theo quy định.</code
                ></span
              >
            </form>
          </div>
        </template>
      </div>

      <div class="wpcf7-response-output wpcf7-display-none"></div>
    </form>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.js';
import moment from 'moment';
import Auction from '@/common/api/auction';
export default {
  name: 'PaymentSuccess',
  mixins: [mixin],
  data() {
    return {
      detail: {},
      code: '',
      codeUser: ''
    };
  },
  filters: {
    formatDate: function(value) {
      if (!value) return '';
      return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
    }
  },
  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.getDetail(urlParams.get('auctionid'));
    this.codeUser = urlParams.get('madangky');
    this.code = urlParams.get('vnp_transactionno');
  },
  methods: {
    getDetail(id) {
      Auction.getDetail(id).then(({ data }) => {
        this.detail = data.Data;
        this.detail.NgayDenXemTaiSan = moment(String(this.detail.NgayDenXemTaiSan)).format('DD/MM/YYYY');
        this.detail.BatDau = moment(String(this.detail.BatDau)).format('HH:mm:ss DD/MM/YYYY');
      });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/PaymentSuccess.vue